import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.slice.js";
export function findValue(value, values) {
  // Convert nested levels to array
  var keys = value.toString().split('.');
  var val;
  // If it has only one level we take the first key and find it in values
  if (keys.length === 1) {
    var firstKey = keys[0];
    val = values[firstKey];
    // Otherwise we should check in the next nested level
  } else if (keys.length > 1) {
    var _firstKey = JSON.parse(JSON.stringify(keys[0]));
    var objProp = values[_firstKey];
    keys = keys.slice(1);
    if (typeof objProp === 'undefined') {
      val = null;
    } else {
      // Remove the first item of keys because we have already accessed
      keys.forEach(function (key, index) {
        if (index + 1 === keys.length) {
          if (typeof objProp === 'undefined') {
            val = null;
          } else {
            val = objProp[key];
          }
        } else {
          if (typeof objProp === 'undefined') {
            val = null;
          } else {
            objProp = objProp[key];
          }
        }
      });
    }
  }
  return val;
}